import { defineStore } from "pinia";
import { ref } from "vue";

export const useBreadCrumbStore = defineStore("breadcrumb_store", () => {
    const routeStack = ref([]);

    function setBreadcrumb(breadcrumbArray) {
        routeStack.value = breadcrumbArray;
    }

    return {
        routeStack,
        setBreadcrumb
    };
})